import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommandesService, CommandePayload } from '../../../services/commandes.service';
import { ClientsService, Client } from '../../../services/clients.service';
import { AdressesService, Adresse } from '../../../services/adresses.service';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';


@Component({
  selector: 'app-commandes-create',
  templateUrl: './commandes-create.component.html',
  styleUrls: ['./commandes-create.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule
  ]
})
export class CommandesCreateComponent implements OnInit {
  commande: CommandePayload = {
    numero_commande: '',
    statut: 'En cours',

    adresse_facturation_id: 0,
    adresses_livraison_ids: [],
    client_id: 0,
    nombre_capteurs: null
  };
  clients: Client[] = [];
  error = '';
  success = '';
  adressesFacturation: Adresse[] = [];
  adressesLivraison: Adresse[] = [];
  saving = false;
  constructor(
    private commandesService: CommandesService,
    private clientsService: ClientsService,
    private adressesService: AdressesService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadClients();
  }
  
  loadClients() {
    this.clientsService.list().subscribe(clients => {
      console.log('clients:', clients);
      this.clients = clients;
      this.cdr.detectChanges();
    });
  }

  onClientChange() {
    this.commande.adresse_facturation_id = 0;
    this.commande.adresses_livraison_ids = [];
    if (!this.commande.client_id) {
      this.adressesFacturation = [];
      this.adressesLivraison = [];
      return;
    }
    this.adressesService.list().subscribe(adresses => {
      this.adressesFacturation = adresses.filter(
        a => a.client_id === this.commande.client_id && String(a.type_adresse ?? '').trim().toLowerCase().replace(/_/g, ' ').includes('facturation')
      );
      this.adressesLivraison = adresses.filter(
        a => a.client_id === this.commande.client_id && String(a.type_adresse ?? '').trim().toLowerCase().replace(/_/g, ' ').startsWith('livraison')
      );
    });
  }

  save() {
    this.saving = true;
    this.commande.statut = 'en cours';
    this.commandesService.create(this.commande).subscribe({
        next: () => {
          this.success = 'Commande créée.';
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.error = err?.error?.detail || err?.message || 'Erreur lors de la création.';
          this.cdr.detectChanges();
        }
    });
  }
}
